import React, { useEffect } from "react";
import { useFieldArray } from "react-hook-form";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import { AreasConfig, templateArea } from "./form-config.jsx";

import FormItem from "../../../components/FormItem";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

export const ServiceAreasFields = ({ name, control, errors, rules, setValue, disabled }) => {
  const { t } = useTranslation();

  const {
    fields: areasFields,
    append,
    remove,
  } = useFieldArray({
    control,
    name,
  });
  useEffect(() => {
    if (areasFields.length === 0) {
      append(templateArea);
    }
  }, [areasFields.length, append]);
  return (
    <>
      <Typography>Адреса зон обслуживания</Typography>
      <Box>
        <Box>
          {areasFields.map((item, index) => (
            <Box
              key={item.id}
              sx={{
                flexBasis: "100%",
                display: "grid",
                gridTemplateColumns: "9fr 1fr",
                gridColumnGap: "0px",
                alignItems: "flex-start",
                paddingBottom: "15px",
                ".error-text": {
                  whiteSpace: "normal",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                }}
              >
                {AreasConfig.map(({ name: itemName, label, input, type, ...rest }) => (
                  <FormItem
                    key={`${name}.${index}.${itemName}`}
                    control={control}
                    errors={errors}
                    disabled={disabled}
                    name={`${name}.${index}.${itemName}`}
                    //label={`Адрес${index + 1}`}
                    input={input}
                    rules={rules}
                    type={type}
                    setValue={setValue}
                    {...rest}
                  />
                ))}
              </Box>

              <Box
                sx={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {index !== 0 && (
                  <Button
                    className="btn btn-remove btn-basket-small"
                    sx={{ color: "red" }}
                    onClick={() => remove(index)}
                  >
                    <DeleteForeverIcon />
                  </Button>
                )}
              </Box>
            </Box>
          ))}
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
          <Button
            className="btn btn-outlined-primary"
            variant="outlined"
            disabled={disabled}
            onClick={() => append(templateArea)}
          >
            {t("button:add")}
          </Button>
        </Box>
      </Box>
    </>
  );
};
